import React, { FC } from 'react'
import styled from 'styled-components'
import { ETypeRequest, IIndexEgePageProps } from '../types'
import SC from '../base/IndexEgePageTeachers.styles'
import { EApplicationFunnels } from '../../../../../components/AppliactionForm/types'
import ImgTopLeft from '../assets/img__teachers_left_top_desktop.png'
import ImgTopRight from '../assets/img__teachers_right_top_desktop.png'
import TeachersBlock from '../../../../../components/Blocks/TeachersBlock/desktop'
import ImgBottomLeft from '../assets/img__teachers_left_bottom_desktop.png'
import ImgBottomRight from '../assets/img__teachers_right_bottom_desktop.png'
import { useSelectProductRequestApplication } from '../../../../../components/SelectProductRequestApplication/bll'

const { Block } = SC

const TopLeft = styled.img`
  position: absolute;
  top: -60px;
  width: 120px;
  left: 0;
  z-index: 1;
`

const TopRight = styled.img`
  position: absolute;
  top: -60px;
  width: 180px;
  right: 0;
  z-index: 1;
`
const BottomLeft = styled.img`
  position: absolute;
  bottom: -120px;
  width: 120px;
  left: 0;
  z-index: 1;
`

const BottomRight = styled.img`
  position: absolute;
  bottom: -120px;
  width: 120px;
  right: 0;
  z-index: 1;
`

const IndexEgePageTeachers: FC<IIndexEgePageProps['content']['aboutTeachers']> = (
  props
) => {
  const { title, list, teachersList, buttonText } = props

  const { selectGroup } = useSelectProductRequestApplication({})

  const handleRequestClick = (): void => {
    selectGroup(EApplicationFunnels.free_lesson, ETypeRequest.ege_lead_free_lesson)
  }

  return (
    <Block id='teachers'>
      <TeachersBlock
        teachersList={teachersList}
        list={list}
        title={title}
        buttonText={buttonText}
        onClick={handleRequestClick}
      />

      <TopLeft src={ImgTopLeft} />
      <TopRight src={ImgTopRight} />
      <BottomLeft src={ImgBottomLeft} />
      <BottomRight src={ImgBottomRight} />
    </Block>
  )
}

export default IndexEgePageTeachers
